module.exports = __webpack_public_path__ + "static/sport/h506.c45fb04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/h506.png
// module id = dWHz
// module chunks = 0